import FarmerDashboard from "./FarmerDashboard";

export default FarmerDashboard;